import { type yup } from '@framework/validation/initYup.ts';
import { ExpressionType } from '../../../../expressions/IExpression.ts';
import { type IFunctionExpression } from '../../../../expressions/repository/function/IFunctionExpression.ts';
import { type IParentWidgetScope } from '../../../IWidgetType.ts';
import { type IComputedStringWidget } from '../IComputedWidget.ts';
import { setComputeTransform } from '../setComputedTransform.ts';
import { hydrateComputedString } from './hydrateComputedString.ts';

export function setComputeStringTransform(
  widget: Pick<IComputedStringWidget, 'expression'>,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
) {
  // Costruisco la FunctionExpression così da poter usare
  // le funzionalità di risoluzione già esistenti
  const expression: IFunctionExpression = {
    type: ExpressionType.Function,
    value: widget.expression,
  };

  return setComputeTransform(
    expression,
    parentScope,
    schema,
    (expression: IFunctionExpression, variables: Record<string, any>) => {
      return hydrateComputedString(expression.value.value, variables);
    },
  );
}
